import React from 'react';
import cx from 'classnames';

import Badge, { BackgroundColor } from '../Badge';

import styles from './index.module.scss';

export interface BadgeDividerProps {
  text: string;
  backgroundColor?: BackgroundColor;
}

const BadgeDivider: React.FC<BadgeDividerProps> = ({
  text,
  backgroundColor,
}) => {
  return (
    <div
      className={cx(styles.wrapper, {
        [styles.green]: backgroundColor === BackgroundColor.GREEN,
      })}
    >
      <Badge
        className={cx(styles.content, {
          [styles.white]: backgroundColor === BackgroundColor.WHITE,
        })}
        text={text}
        backgroundColor={backgroundColor}
      />
    </div>
  );
};

export default BadgeDivider;
